import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { CategoryGridItemSelectionComponent } from '../category-grid-item-selection.component';
import {
  CategoryGridItem,
  CategoryGridStoreService
} from '../category-grid-store.service';
import { GridBreadcrumbComponent } from '../grid-breadcrumb/grid-breadcrumb.component';
import { RetailProductService } from 'src/app/shared/services/retail-product.service';
import { ProductCategoryService } from 'src/app/shared/services/product-category.service';
import { ProductService } from 'src/app/shared/services/product.service';

@Component({
  selector: 'app-category-grid-dialog',
  standalone: true,
  imports: [
    CategoryGridItemSelectionComponent,
    MatDialogModule,
    GridBreadcrumbComponent
  ],
  template: `<h1 mat-dialog-title>Item Finder</h1>
    <div mat-dialog-content>
      <div class="flex flex-col justify-start items-start h-full gap-y-4">
        <app-grid-breadcrumb class="mb-2"></app-grid-breadcrumb>
        <app-category-grid-item-selection
          (itemSelected)="onItemSelected($event)"
          [disableCurrentlyUnavailableItems]="disableCurrentlyUnavailableItems"
          [productType]="productType"
        ></app-category-grid-item-selection>
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-flat-button mat-dialog-close>Cancel</button>
    </div> `,
  providers: [
    CategoryGridStoreService,
    RetailProductService,
    ProductService,
    ProductCategoryService
  ]
})
export class CategoryGridDialogComponent {
  disableCurrentlyUnavailableItems = true;
  productType: 'hire' | 'retail' = 'hire';
  constructor(
    private dialog: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.productType) {
      this.productType = data.productType;
    }
    this.disableCurrentlyUnavailableItems =
      data.disableCurrentlyUnavailableItems;
  }

  onItemSelected(item: CategoryGridItem) {
    if (item.type === 'retailProduct') {
      this.dialog.close(item);
      return;
    }
    if (item.type === 'item') {
      if (item.enabled === false) {
        return;
      }
      this.dialog.close(item.label);
      return;
    }
  }
}
